import request from '@/utils/request'
// 用户列表
export function getUserList (params) {
  return request({
    url: '/hr/userextatt/page/pro',
    method: 'GET',
	params
  })
}
// 任务列表
export function getTaskList (params) {
  return request({
    url: '/hr/crowdtask/page',
    method: 'GET',
	params
  })
}
// 任务详情
export function getDetail (id) {
  return request({
    url: '/hr/crowdtask/info/'+id,
    method: 'GET'
  })
}
// 任务类型
export function getType () {
  return request({
    url: '/sys/dict/type/all/task_requirement_type',
    method: 'GET'
  })
}
// 案例列表
export function getAnliList (params) {
  return request({
    url: '/hr/usercase/fetch',
    method: 'GET',
	params
  })
}
// 个人详情
export function getUserInfo (id) {
  return request({
    url: '/hr/userextatt/info/'+id,
    method: 'GET'
  })
}
// 案例申请访问
export function AnliApply (data) {
  return request({
    url: '/hr/directedauthorization/applyAuth',
    method: 'POST',
	data
  })
}
// 处理访问申请
export function applyHandle (data) {
  return request({
    url: 'hr/directedauthorization/processApply',
    method: 'POST',
	data
  })
}
// 获取申请访问列表
export function getApplyList (params) {
  return request({
    url: '/hr/directedauthorization/apply/page',
    method: 'GET',
	params
  })
}